import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/tel.png'
import _imports_1 from '@/assets/empty.png'


const _withScopeId = n => (_pushScopeId("data-v-0578ba06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding":"0.7rem"} }
const _hoisted_2 = { class: "cls-flex border-btm" }
const _hoisted_3 = { class: "item-uesr" }
const _hoisted_4 = { class: "cls-con" }
const _hoisted_5 = { style: {"color":"#d8c14f"} }
const _hoisted_6 = {
  class: "desc",
  style: {"padding-top":"0.2rem"}
}
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "注册时间：", -1))
const _hoisted_9 = { style: {"color":"#333"} }
const _hoisted_10 = {
  class: "desc",
  style: {"padding-top":"0.1rem"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "锁客时间：", -1))
const _hoisted_12 = { style: {"color":"#333"} }
const _hoisted_13 = { class: "cls-con" }
const _hoisted_14 = {
  class: "desc",
  style: {"padding-top":"0.1rem"}
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系电话：", -1))
const _hoisted_16 = { style: {"color":"#333"} }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"auto","height":"0.9rem"}
}, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"0.2rem"} }, null, -1))
const _hoisted_20 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {"width":"70vw","height":"auto"}
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-tip" }, "暂无客户 ", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_list, {
      loading: _ctx.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
      finished: _ctx.finished,
      "finished-text": _ctx.list.length ? '没有更多了' : '该超级会员还没有客户',
      error: _ctx.error,
      "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.error) = $event)),
      "error-text": "请求失败，点击重新加载",
      onLoad: _ctx.req_items
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.orderCode,
            class: "white-radius",
            style: {"font-size":"0.9rem"}
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_van_image, {
                src: item.thumb,
                width: "2.5rem",
                height: "2.5rem",
                radius: "2rem"
              }, null, 8, ["src"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", null, _toDisplayString(item.name), 1),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(item.levelTxt), 1)
                ]),
                _createElementVNode("div", _hoisted_6, "ID:" + _toDisplayString(item.id), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, _toDisplayString(item.createDate), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(item.bindingDate), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString(item.phone), 1)
              ]),
              (item.memberPhone)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "black cls-flex",
                    onClick: ($event: any) => (_ctx.tel_click(item.leadPhone))
                  }, [
                    _hoisted_18,
                    _hoisted_19,
                    _createTextVNode(" 拨号 ")
                  ], 8, _hoisted_17))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished", "finished-text", "error", "onLoad"]),
    (!_ctx.list.length&&_ctx.reqData.page)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_23))
      : _createCommentVNode("", true)
  ]))
}